<template>
  <v-container>
    <v-layout row wrap mb-3>
        <v-flex xs12>
          In making an application for NEW/RENEWAL of membership of the MCTC, you MUST hereby understand and agree with the persons,
          Organisations, MCTC and bodies corporate that you are entitled to participate in the motorcycle activity/riding at the venue listed, and on
          the terms and conditions set out in this document.
        </v-flex>
    </v-layout>
    <v-layout row wrap mb-3>
        <v-flex xs12 pb-2>
          <strong>1. Acknowledgement Of Risks, Dangers and Obligations</strong><br/>
          <ul>
            <li>That I/we may be injured physically or mentally and may be killed.</li>
            <li>That my/our machinery or equipment may be damaged or destroyed.</li>
            <li>That other riders may ride dangerously or with lack of skill.</li>
            <li>That track or venue conditions may be hazardous and may vary without warning.</li>
            <li>
              That committee members, officials, landowners, track operators and any agents or representative of those in charge of the
              venue are frequently obliged to make decisions under pressure and will not be held responsible.
            </li>
            <li>That any policy of insurance of or in respect to my/our live or physical or mental health may be voided.</li>
            <li>That there may be no facilities or inadequate facilities for treatment or transport, if I/we are injured.</li>
            <li>That I/we have an obligation to all users of the venue to act safely and within the Constitution and Rules of the MCTC.</li>
          </ul>
        </v-flex>
        <v-flex xs12 pb-2>
          <strong>2. Indemnity Given to MCTC</strong><br/>
          In CONSIDERATION of the acceptance of my/our membership, I/we agree to indemnify the MCTC in the following manner:<br/>
          <ul>
            <li>That I/we use the venue at my/our sole risk.</li>
            <li>That I/we accept the venue as it stands with all or any defects hidden and exposed.</li>
            <li>
              That I/we indemnify and hold harmless the MCTC, their respective representatives, committee members, agents or officials
              against any actions or claims which may be made by me/us or on my/our behalf by other parties in respect of or arising out
              of my/our death, injury, loss or damage caused to me/us or my/our machinery or equipment whether caused by negligence,
              breach of contract or in any other manner whatsoever.
            </li>
          </ul>
        </v-flex>
        <v-flex xs12 pb-2>
          <strong>3. No Hassle Policy</strong><br/>
          <ul>
            <li>Any member or persons associated with a member shall conduct themselves in an orderly manner in dealing with the MCTC.</li>
            <li>
              A member shall be responsible for his/her own conduct and that of any person with whom he/she is associated with, who abuses or
              threatens verbally or physically, any official, representative or member of the MCTC.
            </li>
            <li>
              Penalties that may be imposed for a breach include reprimand or warning, exclusion from the track/venue, suspension and/or cancellation of membership.
            </li>
          </ul>
        </v-flex>
        <v-flex xs12 pb-2>
          <strong>4. Track Levy &amp; Working Bee Duty Levy</strong><br/>
          <ul>
            <li>I/we agree to be available to help/supervise the track/venue on agreed days in each membership year.</li>
            <li>I/we agree to be available to attend a working bee on an agreed day in each membership year.</li>
            <li>
              I/we agree to pay a LEVY as laid out below that is refundable to me/us on the completion of the Duties, by cheque at the end of the year. Duties must be completed by the date of the AGM in that
              year or the LEVY is forfeited to the MCTC. The levy is included in the fees below.
            </li>
          </ul>
        </v-flex>
        <v-flex xs12 pb-2>
          <strong>5. Third Party Indemnity For Junior Members</strong><br/>
          I/we, being the PARENT/GUARDIAN of the persons named overleaf, hereby acknowledge:<br/>
          <ul>
            <li>A. That I/we have read the whole of this document and understand it.</li>
            <li>That I/we consent to the member(s) listed overleaf participating in riding at the track/venue.</li>
            <li>That I/we are aware of risks, dangers and obligations set out in Sections 1, 2 & 3.</li>
          </ul>
        </v-flex>
        <v-flex xs12 pb-2>
          <strong>6. Ambulance Cover</strong><br/>
          <ul>
            <li>
              I hereby authorize the Maroondah Cycle Training Club (also referred to as MCTC) representative(s) on duty, to authorize attendance
              of, and transportation by the Victorian Ambulance Service, and any necessary additional medical attention, for myself and/or my
              associated family and persons in my care. In the event that the Ambulance Service attention is required, regardless of cause, I agree
              to meet all costs, however incurred, and will not hold the MCTC and/or it’s representatives liable in any way whatsoever
            </li>
          </ul>
        </v-flex>
        <v-flex xs12 pb-2>
          <strong>7. Right to Use Image</strong><br/>
          <ul>
            <li>
              I acknowledge and consent to photographs and electronic images (including, but not limited to, moving images) being taken of
              me/my children during our attendance at the MCTC track.
            </li>
            <li>
              I acknowledge and agree that such photographs and electronic images
              are owned by MCTC and it may use the photographs and electronic images for promotional or other purposes without my further
              consent being necessary
            </li>
          </ul>
        </v-flex>
        <v-flex xs12 pb-2>
          <strong>8. Membership Fees, Responsibilities & Rebates</strong><br/>
          <ul>
            <li>
              A standard MCTC Membership registration costs <strong>$250 for 12 Months</strong>.
            </li>
            <li>
              New Members are required to pay an additional <strong>$50 Signup Fee</strong>.
            </li>
            <li>
              Registered members are required to perform these duties during this 12 month period:<br/>
              2 Days as Track Supervisor, 1 Day as Track Working Bee Volunteer
            </li>
            <li>
              Members who successfully attend and fulfill all of their track duties are eligible for a $125 Rebate, paid back to them by the Club on completion of these requirements.
            </li>
            <li>
              Elected committee members are eligible for an additional rebate, upon completion of their additional responsibilities
            </li>
            <li>
              I acknowledge and agree to the membership fees outlined above, and the requirements that need to be met for me to receive the membership rebate
            </li>
          </ul>
        </v-flex>
        <v-flex xs12 pb-2>
          <strong>8. I/We acknowledge receipt of a copy of the mctc information pack which forms part of the membership obligation</strong>
        </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
 
export default {
  data () {
    return {
      terms: [
        {
          title: 'Acknowledgement Of Risks, Dangers and Obligations',
          content: ''
        }
      ]
    }
  }
}
</script>
